import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Typography from "../../../../components/Typography/Typography";
import TypographyInline from "../../../../components/Typography/TypographyInline";
import { Button } from "../../../../components/Buttons";
import IconComponent from "../../../../components/Icon/IconComponent";
import {
  GREY,
  BASE,
  BORDER,
  WARNING,
} from "../../../../utils/constants/colors";
import { fontWeight, ICON_LABELS } from "../../../../utils/constants/UI";
import {
  PROFILE_PATH,
  INITIAL_ROUTE,
} from "../../../../utils/constants/routes";

const BUY_PACKAGE_TAB_PATH = `${PROFILE_PATH}?tab=Billing`;

const PaymentCancel = () => {
  const navigate = useNavigate();
  const userDetailsSelector = useSelector((state) => state?.userDetails);
  const payload = userDetailsSelector?.payload;

  // Determine if we should go back to Onboarding or Settings
  const goBackToOnboarding =
    payload &&
    (!payload.account_setting_setup || !payload.general_setting_setup);

  // Auto-redirect onboarding users back to the onboarding form
  useEffect(() => {
    if (goBackToOnboarding) {
      navigate(INITIAL_ROUTE);
    }
  }, [goBackToOnboarding, navigate]);

  const styles = {
    // ... rest of the styles ...
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
      background: BASE.BACKGROUND,
      padding: "24px",
    },
    card: {
      background: BASE.WHITE,
      borderRadius: "12px",
      padding: "48px",
      maxWidth: "500px",
      width: "100%",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "20px",
      border: `1px solid ${BORDER.DEFAULT}`,
    },
    iconWrapper: {
      width: "80px",
      height: "80px",
      borderRadius: "50%",
      background: WARNING.W_50,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    warningIcon: {
      fontSize: "40px",
      color: WARNING.W_500,
    },
    buttonGroup: {
      display: "flex",
      gap: "12px",
      width: "100%",
      marginTop: "8px",
    },
  };

  return (
    <Box style={styles.container}>
      <Box style={styles.card}>
        <Box style={styles.iconWrapper}>
          <IconComponent
            iconLabel={ICON_LABELS.WARNING}
            style={styles.warningIcon}
          />
        </Box>
        <Typography
          size={"lg"}
          color={GREY.PRIMARY}
          fontWeight={fontWeight.BOLD}
          label="Payment Cancelled"
        />
        <TypographyInline
          size={"sm"}
          color={GREY.SECONDARY}
          fontWeight={fontWeight.REGULAR}
          label="Your payment was cancelled. No charges were made to your account."
        />
        <Box style={styles.buttonGroup}>
          <Button
            label={
              goBackToOnboarding ? "Back to Onboarding" : "Back to Billing"
            }
            size={"md40"}
            fullWidth
            variant="primary"
            onClick={() =>
              navigate(
                goBackToOnboarding ? INITIAL_ROUTE : BUY_PACKAGE_TAB_PATH,
              )
            }
          />
        </Box>
      </Box>
    </Box>
  );
};

export default PaymentCancel;
